import classNames from 'classnames';
import React, { forwardRef } from 'react';

import { getButtonClassName } from 'src/components/facilities/buttonCss';
import type { LinkButtonProps } from 'src/components/facilities/link-button';
import LinkButton from 'src/components/facilities/link-button';
import { getHeaderButtonBorderClassName } from 'src/components/layout/redesign/header-mobile/header-mobile-helper';
import type { ButtonStyle } from 'src/enums/button-style';

import type { GeneralRedesignButtonStyle } from '../../../../../cms/common-widgets/button-widget';

export type HeaderButtonLinkProps = {
  type: 'link';
  buttonProps: Queries.RedesignButton;
  handleClick?: () => void;
  className?: string;
  contentClassName?: string;
};

type HeaderSimpleButtonProps = {
  type: 'button';
  text: string;
  handleClick: () => void;
  buttonStyle?: GeneralRedesignButtonStyle;
  className?: string;
  contentClassName?: string;
};

export type HeaderButtonProps = HeaderButtonLinkProps | HeaderSimpleButtonProps;

const HeaderButton = forwardRef<HTMLElement, HeaderButtonProps>((props, ref) => {
  if (props.type === 'link') {
    return (
      props.buttonProps.showButton && (
        <LinkButton
          {...(props.buttonProps as unknown as LinkButtonProps)}
          buttonStyle={props.buttonProps.buttonStyle as ButtonStyle}
          buttonType="grid-button"
          gtmTrackingId="header-button"
          customButtonClassName={getHeaderButtonBorderClassName(props.buttonProps.buttonStyle)}
          iconView={props.buttonProps.buttonIcon}
          handleClick={props.handleClick}
          goToGlobal={!!props.buttonProps.goToGlobal}
          className={props.className}
          contentClassName={props.contentClassName}
          isRedesignButton
          ref={ref}
        />
      )
    );
  } else {
    return (
      <button
        ref={ref as React.ForwardedRef<HTMLButtonElement>}
        type="button"
        className={classNames(
          getButtonClassName(props.buttonStyle),
          getHeaderButtonBorderClassName(props.buttonStyle),
          props.className,
          props.contentClassName
        )}
        onClick={props.handleClick}
      >
        {props.text}
      </button>
    );
  }
});

HeaderButton.displayName = 'HeaderButton';

export default HeaderButton;
